<template>
  <div class="login">
    <div class="loginArea">
      <div v-show="!puzzleShow">
        <div class="logoArea">
          <img src="../assets/images/logoNew.png">
        </div>
        <div class="greeting">欢迎来到店播云后台管理系统！</div>
        <div class="formArea">
          <el-form
            ref="loginForm"
            :model="loginFormData"
            :rules='rules'
          >
            <el-form-item

              prop='username'
            >
              <div class="input-label"><i class="el-icon-user"></i><label>账号</label></div>
              <el-input
                v-model="loginFormData.username"
                placeholder='请输入账号'
              ></el-input>
            </el-form-item>
            <el-form-item

              prop='password'
            >
              <div class="input-label"><i class="el-icon-lock"></i><label>密码</label></div>
              <el-input
                type='password'
                v-model="loginFormData.password"
                placeholder='请输入密码'
              ></el-input>
            </el-form-item>
            <!-- <el-form-item prop='validateCode'>
                    <div class="input-label"><i class="el-icon-key"></i><label>验证码</label></div>
                    <div class="velidateArea">
                      <el-input v-model="loginFormData.validateCode" placeholder='请输入验证码'></el-input>
                      <div class="validateCode"><img :src='validateImgHref'/></div>
                    </div>
                </el-form-item> -->
            <el-form-item>
              <div class="input-label"></div>
              <div class="remberPassword">
                <el-checkbox v-model="remberPassword">记住密码</el-checkbox>
                <router-link
                  to="/phone/changePwd"
                  target="_blank"
                >
                  <div class="forgetPassword">忘记密码?</div>
                </router-link>
              </div>
            </el-form-item>
            <el-form-item>
              <div class="toLoginBtn">
                <el-button
                  type='primary'
                  @click="puzzleValidate()"
                >登录</el-button>
              </div>
            </el-form-item>
            <el-form-item

              prop='agreement'
            >
              <div class="">
                <el-checkbox v-model="loginFormData.agreement">登录表示您已阅读并同意</el-checkbox>
                <router-link
                  to="/userAgreement"
                  target="_blank"
                >
                  <span style="color:#458cff;cursor:pointer">《用户协议》</span>
                </router-link>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div class="regist">
          没有账号?点击<span
            style="color:#458cff;cursor:pointer"
            @click="$router.push('/regist')"
          >注册</span>
        </div>
      </div>
      <!-- <div v-show="puzzleShow">
          <div class="puzzleTitle">
            <span class="backAccount" @click="puzzleShow=false">返回</span>安全验证
          </div>
          <Paper :diff="diff" :tipError.sync='tipError'></Paper>
          <Slide @change="change" @validate='puzzleResult'></Slide>
        </div> -->
    </div>
    <m-footer></m-footer>
    <el-dialog
      title="选择登录角色"
      :visible.sync="roleSelectVisible"
      center
      custom-class='roleSelectBox'
      width="800px"
      :before-close="handleClose"
    >
      <div class="footerBtn">
        <el-radio-group
          size="mini"
          v-model="roleId"
        >
          <el-radio-button
            :key="index"
            v-for="(item,index) in roleOptions"
            :label="item.id"
          >{{item.label}}</el-radio-button>
        </el-radio-group>
      </div>
      <div
        class="footerBtn"
        style="margin-top:10px"
      >
        <el-button
          type='primary'
          @click="selectRoleConfirm()"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/config/api";
import Paper from "@/components/controls/paper.vue";
import Slide from "@/components/controls/slide.vue";
import footer from "@/components/business/footer";

export default {
  components: {
    mFooter: footer,
    Paper,
    Slide,
  },
  data() {
    let checkAgreement = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请先阅读协议"));
      } else {
        callback();
      }
    };
    return {
      roleId: -1, //角色id
      roleOptions: [
        {
          label: "商户",
          id: "B01",
        },
        {
          label: "门店管理员",
          id: "B02",
        },
        {
          label: "操作员",
          id: "B03",
        },
      ],
      tipError: false,
      validateImgHref: "",
      diff: 0,
      puzzleShow: false,
      roleSelectVisible: false,
      loginFormData: {
        username: "",
        password: "",
        // validateCode:'',
        agreement: true,
      },
      rules: {
        username: [{ required: true, message: "请输入账号", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        // validateCode:[
        //   {required:true,message:'请输入验证码',trigger:'blur'}
        // ],
        agreement: [{ validator: checkAgreement }],
      },
      remberPassword: true,
    };
  },
  created() {
    this.refontSize();
    // this.getValidateCode();
  },
  methods: {
    selectRoleConfirm() {
      if (this.roleId == -1) {
        this.$message({
          message: "您有多个角色，请选择其一",
          type: "warning",
        });
        return;
      }
      //此处调用接口传用户选择的角色接口返回成功后跳转路由
    },
    puzzleResult(valid) {
      if (valid) {
        this.login();
        // this.getRole();
      } else {
        this.tipError = true;
      }
    },
    refontSize() {
      document.documentElement.style.fontSize =
        (document.documentElement.clientWidth / 1920) * 10 + "px";
    },
    change(diff) {
      this.diff = diff;
    },
    puzzleValidate() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          // this.puzzleShow=true;
          this.login();
        } else {
          console.log("填写必填字段");
        }
      });
    },
    handleClose() {
      this.roleSelectVisible = false;
    },
    login() {
      let url = api.login;
      let qsData = `username=${
        this.loginFormData.username
      }&password=${this.$utils.md5(this.loginFormData.password)}`;
      console.log("=====", qsData);
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          const loading = this.$loading();
          this.$axios
            .fetchPost(url, qsData, {
              "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
              loginType: 10,
            })
            .then((res) => {
              loading.close();
              if (res.code == 200) {
                this.$utils.setSysUser(res.data.user || {});
                this.$utils.setUserMenu(res.data.menu || {});
                this.$utils.setSessionID(res.data.key);
                this.$router.push({ path: "/index" });
                this.getCacheData();
              } else {
                this.$message({ message: res.errorMsg, type: "error" });
              }
            });
        } else {
          console.log("请输入必填字段");
        }
      });
    },
    getRole(username) {
      //将角色选择重置
      this.roleId = -1;
      setTimeout(() => {
        if (this.roleOptions.length > 1) {
          this.roleSelectVisible = true;
        } else {
          //直接跳转路由
        }
      }, 3000);
    },
    getValidateCode() {
      let url = api.loginValidateCode;
      this.$axios.fetchPostBlob(url).then((res) => {
        this.validateImgHref = URL.createObjectURL(res);
      });
    },
    getCacheData() {
      this.$axios.fetchGet(api.getStatus).then((data) => {
        this.$utils.setCache(data.data || {});
        console.log(data);
      });
    },
  },
};
</script>

<style scoped>
.login {
  width: 100%;
  height: 100%;
  min-width: 1200px;
  background-image: url("../assets/images/login-bg2.png");
  background-size: 100% 100%;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  position: relative;
}

.loginArea {
  width: 30%;
  margin-left: auto;
  margin-right: 10%;
  background-color: #fff;
  padding: 6rem 6rem 3.8rem 6rem;
  border-radius: 2rem;
  font-size: 14px;
}
.loginArea .logoArea {
  width: 20.6rem;
  height: 4.4rem;
}
.loginArea .logoArea img {
  width: 20.6rem;
  height: 4.4rem;
}
.loginArea .greeting {
  margin-top: 2.5rem;
  font-size: 2.4rem;
}
.loginArea .input-label {
  font-size: 16px;
  margin-top: 20px;
  margin-bottom: 1rem;
}
.loginArea .formArea .remberPassword {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
}
.loginArea .formArea .velidateArea {
  display: flex;
  justify-content: space-between;
}
.regist {
  text-align: center;
  margin-top: 30px;
}
/* 验证码样式，已废弃改为拼图验证 */
.validateCode {
  display: inline-block;
  height: 5.4rem;
  line-height: 5.4rem;
  width: 26%;
  vertical-align: bottom;
  text-align: center;
  margin-left: 10px;
  background-color: #f2f2f2;
  border-radius: 1rem;
}
.validateCode img {
  height: 5.4rem;
  width: 100%;
  border: 1px solid #f2f2f2;
}
.forgetPassword {
  color: #458cff;
  cursor: pointer;
}
.toLoginBtn button {
  width: 100%;
  height: 5.4rem;
}
/* 拼图样式 */
.puzzleTitle {
  font-size: 1.6rem;
  color: #000000;
  font-weight: bold;
  margin-bottom: 1rem;
  text-align: center;
  padding: 0px 0px 1rem 0px;
  border-bottom: 1px solid #d7d7d7;
}
.puzzleTitle .backAccount {
  float: left;
  color: #007aff;
  font-size: 1.2rem;
  font-weight: 500;
  cursor: pointer;
  line-height: 2rem;
}

.login >>> .el-input {
  height: 5.4rem;
  width: 100%;
}
.login >>> .el-input__inner {
  height: 5.4rem;
  line-height: 3rem;
  font-size: 16px;
  border: 1px solid #f2f2f2;
  background-color: #f2f2f2;
  border-radius: 1rem;
}
.login >>> .el-input__inner:focus {
  border: 1px solid #458cff;
  background-color: #fff;
  border-radius: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/page/LoginNew.vue